import React from 'react';
import { Image, Calendar } from 'lucide-react';

const StatTile = ({ title, value, icon: Icon, iconBg, iconColor }) => (
  <div
    className='rounded-lg p-6 flex items-center justify-center gap-4 h-full'
    style={{
      background: 'var(--bg-card)',
      border: '1px solid var(--border)',
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    }}
  >
    <div
      className='w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0'
      style={{ background: iconBg }}
    >
      <Icon className='w-6 h-6' style={{ color: iconColor }} />
    </div>
    <div>
      <div className='text-xs font-medium' style={{ color: 'var(--text-muted)' }}>{title}</div>
      <div className='text-2xl font-bold' style={{ color: 'var(--text-primary)' }}>{value}</div>
    </div>
  </div>
);

const StatsSection = ({ stats }) => {
  return (
    <div className='lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6'>
      <StatTile
        title='Total Posts'
        value={stats?.totalPosts ?? 0}
        icon={Image}
        iconBg='rgba(45,212,191,0.15)'
        iconColor='var(--brand)'
      />
      <StatTile
        title='Scheduled'
        value={stats?.scheduledPosts ?? 0}
        icon={Calendar}
        iconBg='rgba(63,239,166,0.15)'
        iconColor='var(--accent)'
      />
    </div>
  );
};

export default StatsSection;
